export { default } from './UgcHomeCarousel.vue';